import {Trans, WithNamespaces, withNamespaces} from 'react-i18next'

import messages from '../../../../assets/messages'
import UiNotification from '../../../Common/UiNotification'

type SubmitResultModalProps = WithNamespaces & {
  isOpen: boolean,
  onClose: () => void,
}

function SubmitResultModalBase(props: SubmitResultModalProps) {
  const {isOpen, onClose, t} = props

  return (
    <UiNotification
      open={isOpen}
      status="success"
      type="payment"
      buttonMessage={t(messages.continue.i18nKey, messages.continue.defaults)}
      onClose={onClose}
    >
      <Trans {...messages.personalDetailsUpdated} />
    </UiNotification>
  )
}

const SubmitResultModal = withNamespaces()(SubmitResultModalBase)

export {SubmitResultModal}
